import React from "react"
import {Checkbox, FormControlLabel, Typography} from "@mui/material"

// Off by default, and says why: assigning the message is a decision about this
// message, but adding the address is a decision about every future one.
function SenderCheckbox({
	address,
	checked,
	onChange,
	disabled,
}: {
	address: string
	checked: boolean
	onChange: (checked: boolean) => void
	disabled: boolean
}) {
	return (
		<FormControlLabel
			control={
				<Checkbox
					size="small"
					checked={checked}
					disabled={disabled}
					onChange={(event) => onChange(event.target.checked)}
				/>
			}
			sx={{alignItems: "flex-start", m: 0}}
			label={
				<Typography variant="body2" mt={0.5}>
					The sender is this customer — add <strong>{address}</strong> to their contact details.{" "}
					<Typography variant="body2" component="span" color="textSecondary">
						Off by default: an added address starts receiving collections mail.
					</Typography>
				</Typography>
			}
		/>
	)
}

export {SenderCheckbox}
